var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.094,
    height: 24,
    viewBox: "0 0 24.094 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Route",
    transform: "translate(-2 -2.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41859",
    "data-name": "Path 41859",
    d: "M8.884,9A6.884,6.884,0,0,0,2,15.884c0,5.5,6.066,10.756,6.325,10.98a.86.86,0,0,0,1.119,0c.3-.224,6.325-5.481,6.325-10.98A6.884,6.884,0,0,0,8.884,9Zm0,16.04C7.447,23.628,3.721,19.7,3.721,15.884a5.163,5.163,0,1,1,10.326,0C14.047,19.7,10.321,23.628,8.884,25.04Z",
    transform: "translate(0 -0.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41860",
    "data-name": "Path 41860",
    d: "M9.581,12.341a2.581,2.581,0,1,0,2.581,2.581A2.581,2.581,0,0,0,9.581,12.341Zm0,3.442a.86.86,0,1,1,.86-.86A.86.86,0,0,1,9.581,15.783ZM21.628,2.11a5.077,5.077,0,0,0-5.163,4.982c0,3.614,3.821,7.047,4.509,7.641a.86.86,0,0,0,1.308,0c.688-.594,4.509-4.027,4.509-7.641A5.077,5.077,0,0,0,21.628,2.11Zm0,10.885c-1.093-1.033-3.442-3.528-3.442-5.9a3.442,3.442,0,1,1,6.884,0c0,2.375-2.349,4.87-3.442,5.9Z",
    transform: "translate(-0.698 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 1.291,
    cy: 1.291,
    r: 1.291,
    transform: "translate(19.64 5.887)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.d3375881fa8d2b2855420c65302bfff7.svg";
export { ForwardRef as ReactComponent };